<template>
  <div>
    <div v-if="item.diagnosis" class="mb-2">
      <b>{{
        $t(
          "horses:horseCarebook.horseMedicalTreatment.diagnosis.label",
          "Diagnosis / Symptoms"
        )
      }}</b>
      <div>
        {{ item.diagnosis }}
      </div>
    </div>
    <div v-if="item.description" class="mb-2">
      <b>{{
        $t(
          "horses:horseCarebook.horseMedicalTreatment.description.label",
          "Treatment description"
        )
      }}</b>
      <div>
        {{ item.description }}
      </div>
    </div>
    <div v-if="item.productComposition" class="mb-2">
      <b>{{
        $t(
          "horses:horseCarebook.horseMedicalTreatment.productComposition.label",
          "Product composition"
        )
      }}</b>
      <div>
        {{ item.productComposition }}
      </div>
    </div>
    <div v-if="item.dosage" class="mb-2">
      <b>{{
        $t(
          "horses:horseCarebook.horseMedicalTreatment.dosage.label",
          "Quantity / dosage"
        )
      }}</b>
      <div>
        {{ item.dosage }}
      </div>
    </div>
    <div v-if="item.administration" class="mb-2">
      <b>{{
        $t(
          "horses:horseCarebook.horseMedicalTreatment.administration.label",
          "Administration"
        )
      }}</b>
      <div>
        {{ item.administration }}
      </div>
    </div>
    <div v-if="item.supplements" class="mb-2">
      <b>{{
        $t(
          "horses:horseCarebook.horseMedicalTreatment.supplements.label",
          "Feed supplements"
        )
      }}</b>
      <div>
        {{ item.supplements }}
      </div>
    </div>
    <div v-if="item.veterinarian" class="mb-2">
      <b>{{
        $t(
          "horses:horseCarebook.horseMedicalTreatment.veterinarian.label",
          "Veterinarian"
        )
      }}</b>
      <div>
        {{ item.veterinarian }}
      </div>
    </div>
  </div>
</template>
<script setup>
defineProps({
  item: {
    type: Object,
    required: true
  }
});
</script>
